import React from 'react'
import { ButtonBase } from './index.styled'

/**
 * The project's only button shape — a pill, sized in design px.
 *
 * @param variant   'outline' (default) or 'filled'.
 * @param width     Design-px width. 100 is the header / Submit pill, 166 the
 *                  footer pills, 113 the cookie-banner pills.
 * @param height    Design-px height. 40 everywhere except the cookie banner (28).
 * @param fontSize  Design-px label size. 20 everywhere except the banner (16).
 * @param mobile    Optional `{ width, height, fontSize }` in *mobile* design px,
 *                  for the pills the mobile comps resize (the header's is 63 x 21
 *                  at 12px). Omit when both comps agree.
 * @param as        The pill is a gatsby `Link` by default — pass a `to`. Use
 *                  `as='button'` for the pills that act (submit, dismiss,
 *                  scroll), or `as='a'` with an `href` for external links.
 */

const Button = ({
  children,
  variant = 'outline',
  width = 100,
  height = 40,
  fontSize = 20,
  mobile,
  type = 'button',
  as,
  ...props
}) => (
  <ButtonBase
    as={as}
    type={as === 'button' ? type : undefined}
    $variant={variant}
    $width={width}
    $height={height}
    $fontSize={fontSize}
    $mobile={mobile}
    {...props}
  >
    {children}
  </ButtonBase>
)

export default Button
